<div class="d-flex flex-column w-100 align-items-center justify-content-center" style="height : 80vh">
  <div class="comment-box">
    <div class="d-flex flex-column">
      @if (permissionErrorMessage) {
        <div class="d-flex flex-column align-items-center text-center">
          <h4 style="color: red">{{ permissionErrorMessage }}</h4>
          <button type="button" class="btn btn-primary mt-3" (click)="closeWindow()">Close</button>
        </div>
      } @else if (!connectionSucceeded) {
        <h4 role="status">Checking the authorization and connecting your account...</h4>
      } @else if (id == 'razorpay') {
        <div class="d-flex flex-row align-items-center">
          <img class="card-img" style="width : 100px" ngSrc="./../../../assets/img/lead-sources/razorpay.svg" width="80"
            height="80" alt="razorpay">
          @if (code) {
            <h4>Your Razorpay Account has been successfully connected</h4>
          }
          @if (!code) {
            <h4 style="color: red">There was some error connecting your Razorpay account</h4>
          }
        </div>
      } @else if (id == 'calendly') {
        <div class="d-flex flex-row align-items-center">
          <img class="card-img" style="width : 100px" ngSrc="./../../../assets/img/lead-sources/calendly.png"
            width="900" height="500" alt="calendly">
          @if (code) {
            <h4>Your Calendly Account has been successfully connected</h4>
          }
          @if (!code) {
            <h4 style="color: red">There was some error connecting your Calendly account</h4>
          }
        </div>
      } @else if (id == 'zohobooks') {
        <div class="d-flex flex-row align-items-center">
          <img class="card-img" style="width : 100px" ngSrc="./../../../assets/img/lead-sources/zohobooks.png"
            width="512" height="512" alt="zohobooks">
          @if (code) {
            <h4>Your Zoho Books Account has been successfully connected</h4>
          }
          @if (!code) {
            <h4 style="color: red">There was some error connecting your Zoho Books account</h4>
          }
        </div>
      } @else if (id == 'zohorecruit') {
        <div class="d-flex flex-row align-items-center">
          <img class="card-img" style="width : 100px" ngSrc="./../../../assets/img/lead-sources/zohorecruit.png"
            width="512" height="512" alt="zohorecruit">
          @if (code) {
            <h4>Your Zoho Recruit Account has been successfully connected</h4>
          }
          @if (!code) {
            <h4 style="color: red">There was some error connecting your Zoho Recruit account</h4>
          }
        </div>
      } @else if (id == 'zohocrm') {
        <div class="d-flex flex-row align-items-center">
          <img class="card-img" style="width : 100px" ngSrc="./../../../assets/img/lead-sources/zoho_crm.png"
            width="1024" height="1024" alt="zohocrm">
          @if (code) {
            <h4>Your Zoho CRM Account has been successfully connected</h4>
          }
          @if (!code) {
            <h4 style="color: red">There was some error connecting your Zoho CRM account</h4>
          }
        </div>
      } @else if (id == 'shopify') {
        <div class="d-flex flex-row align-items-center">
          <img class="card-img" style="width : 100px" ngSrc="./../../../assets/img/lead-sources/shopify.png"
            width="640" height="165" alt="shopify">
          @if (code) {
            <h4>Your Shopify Account has been successfully connected</h4>
          }
          @if (!code) {
            <h4 style="color: red">There was some error connecting your Shopify account</h4>
          }
        </div>
      } @else if (id == 'googleforms') {
        <div class="d-flex flex-row align-items-center">
          <img class="card-img" style="width : 100px" ngSrc="./../../../assets/img/lead-sources/google-forms.png"
            width="825" height="254" alt="google-forms">
          @if (code) {
            <h4>Google Forms has been successfully connected</h4>
          }
          @if (!code) {
            <h4 style="color: red">There was some error connecting your Google Forms</h4>
          }
        </div>
      } @else if (id == 'googlesheets') {
        <div class="d-flex flex-row align-items-center">
          <img class="card-img" style="width : 100px" ngSrc="./../../../assets/img/lead-sources/google-sheets.png"
            width="326" height="155" alt="google-sheets">
          @if (code) {
            <h4>Google Sheets has been successfully connected</h4>
          }
          @if (!code) {
            <h4 style="color: red">There was some error connecting your Google Sheets</h4>
          }
        </div>
      } @else if (id == 'googledrive') {
        <div class="d-flex flex-row align-items-center">
          <img class="card-img" style="width : 100px" ngSrc="./../../../assets/img/lead-sources/google-drive.png"
            width="326" height="155" alt="google-drive">
          @if (code) {
            <h4>Google Drive has been successfully connected</h4>
          }
          @if (!code) {
            <h4 style="color: red">There was some error connecting your Google Drive</h4>
          }
        </div>
      } @else if (id == 'gmeet') {
        <div class="d-flex flex-row align-items-center">
          <img class="card-img" style="width : 100px" ngSrc="./../../../assets/img/lead-sources/google-meet.png"
            width="600" height="600" alt="google-meet">
          @if (code) {
            <h4>Google Meets has been successfully connected</h4>
          }
          @if (!code) {
            <h4 style="color: red">There was some error connecting your Google Meets Account</h4>
          }
        </div>
      } @else if (id == 'instagram') {
        <div class="d-flex flex-row align-items-center">
          <img class="card-img" style="width : 100px" ngSrc="./../../../assets/img/lead-sources/instagram-messenger.png"
            width="600" height="600" alt="instagram-dm">
          @if (code) {
            <h4>Instagram has been successfully connected</h4>
          }
          @if (!code) {
            <h4 style="color: red">There was some error connecting your Instagram Account</h4>
          }
        </div>
      }
    </div>
  </div>
</div>
